import { createAction } from '@ngrx/store';
import { ProgramFilters } from '../../core/models/ProgramFilters';

export const getProgramFilters = createAction('[ProgramFilters] Get Program Filters');
export const setProgramFilters = createAction('[ProgramFilters] Set ProgramFilters', (programFilters: ProgramFilters) => programFilters);
export const clearProgramFilters = createAction('[ProgramFilters] Clear ProgramFilters');
